/* THE RYZE JOURNAL (dev2.14-journal W4; dev2.15-journal2, RYZE_Part65_CC3, 30 Oct 2026).
   1. The Q&A accordion: one answer open at a time, like the FAQ page; THE STANDARD TOGGLE MARK
      turns off aria-expanded (assets/ryze-journal.css). The answers are server-rendered open
      (aria-expanded="true") and stay readable without this script: init sets every button to
      false and adds .is-ready, which is what collapses them.
   2. THE LANGUAGE TOGGLE remembers the viewer's pick (localStorage 'ryze-journal-lang', a
      convenience only; the links are plain links and the URL is the truth). The English index
      reads it inline before its grid paints (sections/main-blog.liquid).
   3. Share: the foot row's Share button appears only where the device shares natively
      (navigator.share: iPhone Safari, Android); it shares the page's own address and title. */
(function () {
  function setOpen(item, open) {
    var btn = item.querySelector('.rj-qa__btn');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function initQa(root) {
    if (root.classList.contains('is-ready')) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.rj-qa__item'));
    items.forEach(function (item) {
      var btn = item.querySelector('.rj-qa__btn');
      if (!btn) return;
      setOpen(item, false);
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (other) { setOpen(other, false); });
        if (!wasOpen) setOpen(item, true);
      });
    });
    root.classList.add('is-ready');
  }
  function initLang(nav) {
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('[data-rj-lang-pick]');
      if (!a) return;
      try { localStorage.setItem('ryze-journal-lang', a.getAttribute('data-rj-lang-pick')); } catch (err) {}
    });
  }
  function initShare(btn) {
    if (typeof navigator.share !== 'function') return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var canon = document.querySelector('link[rel="canonical"]');
      navigator.share({
        title: btn.getAttribute('data-rj-share-title') || document.title,
        url: canon ? canon.href : location.href
      }).catch(function () {});
    });
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.rj-qa'), initQa);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rj-lang]'), initLang);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rj-share]'), initShare);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
